import { render } from "./Speaker75.vue?vue&type=template&id=bde2a2c8"
import script from "./Speaker75.vue?vue&type=script&lang=js"
export * from "./Speaker75.vue?vue&type=script&lang=js"
script.render = render

export default script